<template>
  <v-container id="result-report" fluid tag="section">
    <filter-form :filter-form="filterForm" />
    <report-table v-show="!loading" :reports="reports" />
    <RevenueReportChart v-if="!loading && departmentMinutes.length" :dataChart="dataChart" />
    <RatioReportChart v-if="!loading && departmentMinutes.length" :dataChart="dataChart" />
    <v-card v-if="!loading && departmentMinutes.length == 0" class="pb-2">
      <common-no-result />
    </v-card>
  </v-container>
</template>
<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment';
import FilterForm from './components/FilterForm';
import ReportTable from './components/ReportTable';
import RevenueReportChart from './components/RevenueReportChart'
import RatioReportChart from './components/RatioReportChart';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ReportRepository = RepositoryFactory.get('report');
export default {
  components: { FilterForm, ReportTable, RevenueReportChart, RatioReportChart },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        },
        shift: [],
        departmentId: '',
        departmentIds: []
      },
      reports: {},
      departmentMinutes: [],
      dataChart: {
        labels: [],
        successTurnOver: [],
        initTurnOver: [],
        departmentInitLatchRatio: []
      },
      loading: true
    };
  },
  created() {
    this.getAPIReport();
    Bus.$on('report-list-filter-thpt', filterForm => {
      this.filterForm = filterForm;
      this.getAPIReport();
    });
  },
  beforeDestroy() {
    Bus.$off('report-list-filter-thpt');
  },
  methods: {
    async getAPIReport() {
      const loader = this.$loading.show();
      this.loading = true;
      await Promise.all([
        this.getDepartmentSummary(),
        this.getDepartmentChart()
      ]);
      this.loading = false;
      loader.hide();
    },
    async getDepartmentSummary() {
      const params = {
        startDate: this.formatDate(this.filterForm.dateRange.startDate),
        endDate: this.formatDate(this.filterForm.dateRange.endDate),
        shift: this.filterForm.shift,
        departmentIds: this.filterForm.departmentIds,
        departmentType: 'retail',
        schoolLevelIds: [2]
      };

      // if (!params.departmentId && !this.isManager()) {
      //   const dataUser = TokenService.getUser() || {};
      //   params.departmentId = dataUser.departmentId;
      // }

      const response = await ReportRepository.departmentSummary(params);
      if (response.success) {
        this.reports = _.get(response, 'data', {});
      }
    },
    async getDepartmentChart() {
      const params = {
        startDate: this.formatDate(this.filterForm.dateRange.startDate),
        endDate: this.formatDate(this.filterForm.dateRange.endDate),
        shift: this.filterForm.shift,
        departmentIds: this.filterForm.departmentIds,
        departmentType: 'retail',
        schoolLevelIds: [2]
      };

      if (!params.departmentId && !this.isManager()) {
        const dataUser = TokenService.getUser() || {};
        params.departmentId = dataUser.departmentId;
      }

      const response = await ReportRepository.departmentChart(params);
      if (response.success) {
        this.departmentMinutes = _.get(response, 'data', []);
        this.getMultiLineData();
      } else {
        this.departmentMinutes = []
      }
    },
    getMultiLineData() {
      const labels = [];
      const successTurnOver = [];
      const initTurnOver = [];
      const departmentInitLatchRatio = [];
      this.departmentMinutes.forEach(data => {
        const label = Object.keys(data)[0];
        labels.push(label);
        successTurnOver.push(Number(_.get(data, `${label}.successTurnOver`, 0) / 1000000).toFixed(2));
        initTurnOver.push(Number(_.get(data, `${label}.initTurnOver`, 0) / 1000000).toFixed(2));
        departmentInitLatchRatio.push(_.get(data, `${label}.departmentInitLatchRatio`, 0).toFixed(2));
      });
      this.dataChart = {
        labels,
        successTurnOver,
        initTurnOver,
        departmentInitLatchRatio
      };
    }
  }
};
</script>
